import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {AlertComponent} from './alert/alert.component';
import {AlertLinkComponent} from './alert-link/alert-link.component';
import {AlertIconComponent} from './alert-icon/alert-icon.component';
import {AlertChipComponent} from './alert-chip/alert-chip.component';
import {AlertActionComponent} from './alert-action/alert-action.component';
import {RouterModule} from '@angular/router';

@NgModule({
  declarations: [AlertComponent, AlertLinkComponent, AlertIconComponent, AlertChipComponent, AlertActionComponent],
  imports: [CommonModule, MatIconModule, RouterModule],
  exports: [AlertComponent, AlertLinkComponent, AlertIconComponent, AlertChipComponent, AlertActionComponent],
})
export class AlertModule {}
